/* We need to explicitly set the page context:
   in some cases segment may send the previous page context
   (e.g., if the event fires before the current page has fully mounted or updated) */
export const getPageContext = () => {
  if (typeof window === 'undefined' || !window || !document) {
    return undefined
  }

  const { search, pathname: path, href: url } = window.location
  const { referrer, title } = document

  return {
    path,
    url,
    search,
    title,
    ...(referrer && { referrer }),
  }
}
